import { render } from "./AppDialog.vue?vue&type=template&id=c366855e&lang=pug"
import script from "./AppDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=c366855e&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__